// extracted by mini-css-extract-plugin
module.exports = {"form":"ForgotPasswordForm_form__byFfO","confirmButton":"ForgotPasswordForm_confirmButton__36uF7"};